import {
  Box,
  InputProps,
  forwardRef,
  FormControl,
  FormLabel,
  Text,
} from '@chakra-ui/react';
import theme from 'ui/theme/theme';
import PhoneInputWithCountrySelect from 'react-phone-number-input';
import { CountryCode, E164Number } from 'libphonenumber-js';

type FormPhoneProps = {
  label: string;
  errorMessage: any;
  defaultCountry: CountryCode;
  formControl: any;
  onChangeCallback: (value: E164Number) => void;
} & InputProps;

const FormPhoneItem = forwardRef<FormPhoneProps, 'input'>(
  (
    {
      label,
      errorMessage,
      defaultCountry,
      formControl,
      onChangeCallback,
      ...inputProps
    },
    ref
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { value, ...rest } = inputProps;
    return (
      <FormControl isInvalid={errorMessage} isRequired={inputProps.required}>
        <Box padding="10px 0px" w="full">
          <FormLabel>{label}</FormLabel>
          <PhoneInputWithCountrySelect
            ref={ref}
            {...rest}
            smartCaret={false}
            control={formControl}
            onChange={onChangeCallback}
            defaultCountry={defaultCountry}
            displayInitialValueAsLocalNumber
            international
            limitMaxLength
            style={{
              border: 'solid 2px #e2e8f0',
              borderRadius: '5px',
              height: '50px',
              overflow: 'hidden',
              '--PhoneInputCountrySelectArrow-color': theme.colors.primaryColor,
              '--PhoneInputCountryFlag-borderColor': theme.colors.primaryColor,
            }}
          />
          {errorMessage && <Text color="red">{errorMessage}</Text>}
        </Box>
      </FormControl>
    );
  }
);

export default FormPhoneItem;
